import { Controller } from "react-hook-form";

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";

const FlexControlledCheckboxSeparatedLabel = ({
	control,
	name,
	error,
	label,
	options,
	labelProps,
	className,
	labelStyles,
	inputStyles,
	checkboxStyles,
	...rest
}) => {
	return (
		<Controller
			control={control}
			name={name}
			render={({ field: { onChange, value } }) => (
				<Box
					sx={{
						display: "flex",
						gap: "10px",
						alignItems: "center",
						width: "100%",
					}}
				>
					<Box
						sx={{
							flex: "0",
							display: "flex",
							alignItems: "center",
							height: "100%",
							...labelStyles,
						}}
					>
						<Typography
							noWrap
							variant="label"
							component="label"
							htmlFor={name}
							sx={{ ...labelProps }}
						>
							{label}:
						</Typography>
					</Box>
					<Box
						sx={{
							flex: "1",
							display: "flex",
							alignItems: "center",
							...inputStyles,
						}}
					>
						<FormControlLabel
							error={error ? 1 : 0}
							sx={{ mr: 0 }}
							control={
								<Checkbox
									id={name}
									checked={!!value}
									sx={checkboxStyles}
									onChange={onChange}
									{...rest}
								/>
							}
						/>
					</Box>
				</Box>
			)}
		/>
	);
};

export default FlexControlledCheckboxSeparatedLabel;
